// src/context/ArchiveContext.tsx
import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ArchiveContextType {
  isArchiveMode: boolean;
  setIsArchiveMode: (mode: boolean) => void;
}

const ArchiveContext = createContext<ArchiveContextType>({
  isArchiveMode: false,
  setIsArchiveMode: () => {},
});

export const useArchiveContext = () => {
  const context = useContext(ArchiveContext);
  if (!context) {
    throw new Error('useArchiveContext must be used within an ArchiveProvider');
  }
  return context;
};

export const ArchiveProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isArchiveMode, setIsArchiveMode] = useState(false);

  return (
    <ArchiveContext.Provider value={{ isArchiveMode, setIsArchiveMode }}>
      {children}
    </ArchiveContext.Provider>
  );
}; 